<template>
    <div>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="11">
                        <v-card-title class="titulopagina">REPORTE  DE  LOTES</v-card-title>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                            <v-icon color="blue" large>help</v-icon>
                        </v-alert>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <modal-ayuda></modal-ayuda>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="1"></v-col>
                    <v-col cols="3">
                        <v-text-field
                        class="float-left"
                        dense
                        @keyup.enter.native="buscarLotes"
                        v-model="nombre_lote"
                            label="Lote..."
                        ></v-text-field>
                    </v-col>
                    <v-col cols="3">
                        <date-picker class="float-right" v-model="fechas" range-separator="|" range placeholder ="Seleccione Rango de Fechas" format="DD-MM-YYYY" :default-value="fechas" valueType="YYYY-MM-DD"></date-picker>
                    </v-col>
                    <v-col cols="2">
                        <v-checkbox
                        v-model="par"
                        :label="`Incluir Parametros`"
                        ></v-checkbox>
                    </v-col>
                    <v-col cols="3">
                        <v-btn class="ml-2" @click="cargarLotes" color="blue darken 1" dark>Consultar</v-btn>
                        <v-btn class="ml-2" @click="download" color="green darken 1" v-bind:disabled="!can_download" dark>Excel</v-btn>
                    </v-col>
                </v-row>
                <v-row><i class="v-icon notranslate material-icons">info</i><p>* Para buscar por lote, escriba el lote y presione enter... para buscar por rango de fechas, seleccione las fechas y de click a Consultar</p></v-row>
            </v-card-text>
        </v-card>

         <!-- <v-card>
             <v-row class="ml-1 mr-1 mt-2">
                    <v-col>Lote</v-col>
                    <v-col>Fecha Elaboración</v-col>
                    <v-col>Maxisacos disponibles</v-col>
                    <v-col>Jumbos despachados</v-col>
                    <v-col>Total Maxisacos</v-col>

            </v-row>
         </v-card> -->

                <v-row class="ml-1 mr-1 mt-2" justify="center">
                    <v-expansion-panels accordion>
                    <v-expansion-panel
                        v-for="(lote,i) in lotes"
                        :key="i"
                    >
                        <v-expansion-panel-header>
                            <v-row>
                                <v-col>{{`Lote: ${lote.nombre_lote}`}}</v-col>
                                <v-col>{{`Fecha Elaboración: ${moment(lote.fecha_produccion).format('DD-MM-YYYY')}`}}</v-col>
                                <v-col>{{`Maxisacos Disponibles: ${lote.maxisacos_disponibles}`}}</v-col>
                                <v-col>{{`Maxisacos Despachados: ${lote.maxisacos_despachados}`}}</v-col>
                                <v-col>{{`Total Maxisacos: ${lote.total_maxisacos}`}}</v-col>

                            </v-row>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                        <v-card>
                            <v-simple-table dense>
                                <thead>
                                    <tr>
                                        <th class="cabecera">Fecha</th>
                                        <th class="cabecera">Lote</th>
                                        <th class="cabecera">N°</th>
                                        <th class="cabecera">Peso</th>
                                        <th class="cabecera" v-for="p in parametros" :key="p.id">{{p.nombre_parametro}}</th>
                                        <th class="cabecera">Disponible</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(jumbo,i) in lote.jumbos" :key="i">
                                        <td class="text-center">{{jumbo.fecha | fechaCompleta}}</td>
                                        <td class="text-center">{{lote.nombre_lote}}</td>
                                        <td class="text-center">{{jumbo.nro_jumbo}}</td>
                                        <td class="text-center">{{jumbo.peso}}</td>
                                        <td class="text-center" v-for="p in parametros" :key="p.id">
                                            {{retornarValor(jumbo,p.id)}}
                                        </td>
                                        <td v-if="jumbo.disponible == 'SI'" class="text-center"><v-icon color="green darken-1">done</v-icon><v-icon v-if="jumbo.repasado != null" color="red darken-1" title="Repasado">R</v-icon></td>
                                        <td v-if="jumbo.disponible == 'NO'" class="text-center"><v-icon color="red darken-1">block</v-icon><v-icon v-if="jumbo.repasado != null" color="red darken-1" title="Repasado">R</v-icon></td>

                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-card>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    </v-expansion-panels>
                </v-row>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import ModalAyudas from '../../components/shared/ModalAyudas.vue';
export default {
    data:()=>({
        lotes:[],
        fechas:null,
        url_excel: '',
        can_download: false,
        nombre_lote:'',
        parametros:[
            {id:1,nombre_parametro:'Humedad',mostrar:true},
            {id:4,nombre_parametro:'Grasa',mostrar:false},
            {id:6,nombre_parametro:'TVN',mostrar:true}
        ],
        par:false,
    }),
    mounted(){
        this.fechas = this.moment().format('YYYY-MM-DD');
        this.cargarLotes();
    },
    methods:{
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Reporte de Lotes`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se muestra un listado de lotes y sus respectivos maxisacos. Se puede buscar por lote o por un rango de fechas, además de poder incluir los parámetros de estos y exportar toda la información a Excel.`},
                {   tipo:`label`,   texto:`- Para buscar por lote, escriba el lote y presione enter... para buscar por rango de fechas, seleccione las fechas y de click a Consultar. Si desea incluir parámetros, marque la casilla correspondiente.`},
                {   tipo:`label`,   texto:`- Se mostrará un listado con cada lote encontrado según los filtros puestos con sus datos generales, como la fecha de elaboración, maxisacos disponibles, despachados y totales. Además, para cada lote del listado, se puede ver su detalle pulsando en la fila correspondiente. Esto mostrará el detalle de cada maxisaco del lote, con la fecha, número, peso y parámetros (en caso de haberlo indicado) y si está disponible o no.`},
                {   tipo:`label`,   texto:`- Al pulsar el botón "Excel", se exportará toda la información mostrada según los filtros indicados en formato Excel.`},
            ];
            
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarLotes(){
          //this.mostrarLoading('Cargando Lotes...');
            this.mostrarLoading({titulo:'Cargando Lotes...',color:'green'})

          this.can_download = false;
          //let url = `${this.base_url}reporte_lotes/${this.fechas[0]}/${this.fechas[1]}/${this.par}`;

            let url = `${this.base_url}lotes/detalle_lotes_jumbos`;
            let data = {
                nombre_lote: '',
                params: this.par,
                fecha_ini_lote: this.fechas[0],
                fecha_fin_lote: this.fechas[1]
            }
            //await this.axios.get(url, this.headers).then((response)=>{
            await this.axios.post(url, data, this.headers).then((response)=>{

                this.lotes = response.data.data;
                this.url_excel = response.data.url_excel;
                console.log('lotes', this.lotes);
                if(this.url_excel.length > 0){
                    this.can_download = true;
                }
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },

        async buscarLotes(){
            //this.mostrarLoading('Cargando Lotes...');
            this.mostrarLoading({titulo:'Cargando Lotes...',color:'green'})

            this.can_download = false;
            // let url = `${this.base_url}reporte_lotes/${this.nombre_lote}/${this.par}`;
            let url = `${this.base_url}lotes/detalle_lotes_jumbos`;
            let data = {
                nombre_lote: this.nombre_lote,                
                params: this.par, 
                fecha_ini_lote: '',
                fecha_fin_lote: ''
            }
            //await this.axios.get(url, this.headers).then((response)=>{
            await this.axios.post(url, data, this.headers).then((response)=>{
                this.lotes = response.data.data;
                this.url_excel = response.data.url_excel;
                console.log('lotes', this.lotes);
                if(this.url_excel.length > 0){
                    this.can_download = true;
                }
                this.ocultarLoading();
            }).catch((error)=>{
                console.log('error',error);
                this.ocultarLoading();
            });
        },

        retornarValor(jumbo,p){
            let valor = '';
            if(jumbo.resultado_detalles != null){
                let item = jumbo.resultado_detalles.find(r => r.parametros_id == p);
                if(item){
                    valor = item.valor;
                }
            }
            return valor;
        },
        download(){
            window.location.href = this.download_url + this.url_excel;
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url', 'headers', 'download_url'])
    },
    components:{
        DatePicker,
        'modal-ayuda': ModalAyudas,
    }
}
</script>